module.exports = __webpack_public_path__ + "img/customer-group.f0de79a0.png";